module.exports = __webpack_public_path__ + "static/media/cauldron.fc45ec31.svg";